import React from 'react';
import ActiveScreens from './ActiveScreens';

export function renderActiveScreens(root, props: any) {
    root.render(<ActiveScreens {...props} />);
}
